module.exports = __webpack_public_path__ + "static/scale-model-of-you-are-the-star-in-glendale-california-3c82fce44afbbff9733eb6550b9bf18e.png";